import { isBrowserEnv } from "./constants";

const useHost = () => {
  if (isBrowserEnv) return window.location.host;

  if (process.env.host) return process.env.host;

  return "www.cointr.com";
};

export default useHost;
